import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for legacy `/libraries/plan/*` (v1).
 *
 * Distinct from `/libraries/plan-packages/*` (v2) paths in `planPackagesPaths.ts`.
 */
export const planListRoute = defineRoute("/libraries/plan");
export const planDetailsRoute = defineRoute("/libraries/plan/:planPackageId/:planPackageVersionId");
export const planTakeoffsRoute = defineRoute("/libraries/plan/:planPackageId/:planPackageVersionId/takeoffs");
export const planIncomingSlotReviewRoute = defineRoute(
  "/libraries/plan/:planPackageId/:planPackageVersionId/incoming-slot-review",
);
